package com.tovtalk.presentation.viewmodel.auth

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

data class AuthSheetState(
    val visible: Boolean = false,
    /** Translation key describing why auth is needed (e.g. "auth_sheet_reason_like"). */
    val reason: String? = null,
)

class AuthSheetController {
    private val _state = MutableStateFlow(AuthSheetState())
    val state: StateFlow<AuthSheetState> = _state.asStateFlow()

    fun open(reason: String? = null) {
        _state.value = AuthSheetState(visible = true, reason = reason)
    }

    fun dismiss() {
        _state.value = AuthSheetState(visible = false, reason = null)
    }

    /** Call after successful auth from the sheet. Same as dismiss for now. */
    fun onAuthSuccess() = dismiss()
}
